// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"225":"49e421b3","395":"9cd5e8cf","530":"e8ae3001","571":"8749417f","693":"6c0f98ca","885":"834830bc"}[chunkId] + ".chunk.css";
};